import type {SmartPv12Product} from '@smart/analytics';
import type {ProductSearchProduct} from '../../bff/product-search-model/create-product-search-model';
import type {Banner} from '../../bff/types';

/**
 * Utility function for mapping a list of product search products
 * into a list of products for tracking/analytics.
 *
 * allProducts param are used to track the correct index in the total
 * list of loaded products
 *
 * @param products - the products that will be tracked
 * @param allProducts - optional list with all products (should contain `products`)
 * @returns
 */

export const getProductsForAnalytics = (
  products: (ProductSearchProduct | Banner)[],
  allProducts?: (ProductSearchProduct | Banner)[],
): SmartPv12Product[] => {
  return products
    .filter((item) => item.type === `product`)
    .map<SmartPv12Product>((p, index) => ({
      id: p.productId,
      index: (
        allProducts
          ?.filter((item) => item.type === `product`)
          ?.findIndex((ap) => ap.productId === p.productId) ?? index
      ).toString(),
      name: p.headline,
      type: p.productType,
      priceUnit: p.totalPriceRaw,
      qty: 1,
      priceTotal: p.totalPriceRaw,
      inStock: p.stockLevelStatus,
      model: p.brandName,
    }));
};
